export function parseUnknownDef() {
    return {};
}
